/** Matches backend PolicyContentFormat.RichHtml */
export const POLICY_CONTENT_FORMAT_RICH_HTML = 1;

export type PolicyContentFormatValue = 0 | 1 | 'Plain' | 'RichHtml';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function looksLikeRichHtml(text: string): boolean {
  return /<\s*(p|h[1-4]|ul|ol|li|strong|em|u|br)\b/i.test(text);
}

function plainTextToHtml(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return '';
  const paragraphs = escapeHtml(trimmed).split(/\n\s*\n/);
  return paragraphs
    .map((block) => `<p>${block.replace(/\n/g, '<br/>')}</p>`)
    .join('');
}

/** Strip scripts, event handlers, and javascript: URLs from rich HTML before render. */
export function sanitizeRichHtmlForDisplay(html: string): string {
  if (!html) return '';
  let out = html.replace(/<(script|style|iframe|object|embed)[^>]*>[\s\S]*?<\/\1>/gi, '');
  out = out.replace(/<\s*(script|style|iframe|object|embed)[^>]*\/?>/gi, '');
  out = out.replace(/\s+on\w+\s*=\s*(['"])[^'"]*\1/gi, '');
  out = out.replace(/\s+on\w+\s*=\s*[^\s>]+/gi, '');
  out = out.replace(/\shref\s*=\s*(['"])\s*javascript:[^'"]*\1/gi, ' href="#"');
  out = out.replace(/\ssrc\s*=\s*(['"])\s*javascript:[^'"]*\1/gi, '');
  return out;
}

/** HTML safe to pass to dangerouslySetInnerHTML for policy bodies. */
export function resolvePolicyDisplayHtml(
  text: string | null | undefined,
  contentFormat?: PolicyContentFormatValue | number | null
): string {
  const raw = text ?? '';
  if (!raw) return '';
  let html: string;
  if (
    contentFormat === POLICY_CONTENT_FORMAT_RICH_HTML ||
    contentFormat === 'RichHtml' ||
    looksLikeRichHtml(raw)
  ) {
    html = raw;
  } else {
    html = plainTextToHtml(raw);
  }
  return sanitizeRichHtmlForDisplay(html);
}

/** Prepare legacy plain text for the Quill editor. */
export function policyTextForEditor(
  text: string | null | undefined,
  contentFormat?: PolicyContentFormatValue | number | null
): string {
  const raw = text ?? '';
  if (
    contentFormat === POLICY_CONTENT_FORMAT_RICH_HTML ||
    contentFormat === 'RichHtml' ||
    looksLikeRichHtml(raw)
  ) {
    return raw;
  }
  return plainTextToHtml(raw);
}
